import {ChangeDetectionStrategy, Component, input, output} from '@angular/core';
import {DatePipe} from '@brunata-angular/ui';
import {TranslatePipe} from '@brunata-angular/util';
import {SavedExport} from '../saved-export.model';
import {DeliveryOutcomeIconComponent} from '../delivery-outcome-icon/delivery-outcome-icon.component';

@Component({
    selector: 'app-delivery-status',
    standalone: true,
    imports: [DatePipe, DeliveryOutcomeIconComponent, TranslatePipe],
    template: `
        @if (savedExport().sftpConnectionMissing) {
            @let connectionMissingLabel =
                'savedexport_deliverylog_reason_connection_missing'
                    | translate: 'online' : 'export';
            <span
                class="d-inline-flex align-items-center gap-2 text-danger text-nowrap"
                [title]="connectionMissingLabel">
                <i class="bi bi-exclamation-triangle-fill" aria-hidden="true"></i>
                {{
                    'savedexport_deliverylog_reason_short_connection_missing'
                        | translate: 'online' : 'export'
                }}
            </span>
        } @else if (savedExport().recurrence === null) {
            <span class="text-secondary">
                {{ 'savedexport_deliverylog_on_demand' | translate: 'online' : 'export' }}
            </span>
        } @else if (savedExport().lastDeliveryOutcome; as outcome) {
            <button
                type="button"
                class="btn btn-link p-0 text-decoration-none d-inline-flex align-items-center gap-2"
                [class.flex-wrap]="wrap()"
                [class.justify-content-end]="wrap()"
                (click)="viewLog.emit()">
                <app-delivery-outcome-icon [outcome]="outcome" />
                <span class="d-inline-flex align-items-center gap-2 text-nowrap">
                    <span class="text-secondary fw-normal">
                        {{ savedExport().lastDeliveryDate | appdate }}
                    </span>
                    <i class="bi bi-chevron-right" aria-hidden="true"></i>
                </span>
            </button>
        } @else {
            <span class="text-secondary">
                {{ 'savedexport_deliverylog_not_delivered_yet' | translate: 'online' : 'export' }}
            </span>
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeliveryStatusComponent {
    readonly savedExport = input.required<SavedExport>();
    readonly wrap = input(false);
    readonly viewLog = output<void>();
}
